<div class="document-section" [class.file-manager]="showFilesInfo">
    <div class="files-preview-container" [ngClass]="{'active': docsEditable}">
        <div class="dnd-container" *ngIf="!files.length" [hidden]='docsEditable'>
            <h4>{{ 'group.NoFiles' | translate }}</h4>
        </div>

        <div class="files-list">
            <div class="file-item" *ngFor="let file of files; let i = index">
                <div class="file-details">
                    <div class="file-icon">

                        <img *ngIf='fileType(file.name) == "doc"'
                            src="./assets/images/file-icons/file-doc-icon.svg">

                        <img *ngIf='fileType(file.name) == "jpg"'
                            src="./assets/images/file-icons/file-jpg-icon.svg">

                        <img *ngIf='fileType(file.name) == "pdf"'
                            src="./assets/images/file-icons/file-pdf-icon.svg">

                        <img *ngIf='fileType(file.name) == "png"'
                            src="./assets/images/file-icons/file-png-icon.svg">

                        <img *ngIf='fileType(file.name) == "xls"'
                            src="./assets/images/file-icons/file-xls-icon.svg">

                        <img *ngIf='fileType(file.name) == "zip"'
                            src="./assets/images/file-icons/file-zip-icon.svg">

                        <img *ngIf='fileType(file.name) == "ppt"'
                          src="./assets/images/file-icons/file-ppt-icon.svg">

                    </div>
                    <div>
                        <label [title]="file?.name">{{ file?.name }}</label>
                        <span>{{ formatBytes(file?.size) }}</span>
                    </div>
                </div>
                <div class="file-btn">
                  <!-- [href]="file.path" [download]="file.path"  target="_blank" -->
                    <a class="download" href="javascript:void(0)" (click)="downloadImg(file)">
                        <svg width="16" height="16" viewBox="0 0 16 16">
                            <path id="download-btn"
                                d="M-168.666-163h-14.669a.667.667,0,0,1-.665-.669v-3.907a.668.668,0,0,1,.666-.67.669.669,0,0,1,.667.67v3.233h13.336v-3.233h0a.667.667,0,0,1,.665-.669h0a.667.667,0,0,1,.665.669h0v3.9a.667.667,0,0,1-.665.669Zm-7.823-4.45-3.831-4.143h0a.671.671,0,0,1-.178-.457.671.671,0,0,1,.668-.672.664.664,0,0,1,.49.215l2.675,2.895v-8.717A.669.669,0,0,1-176-179a.669.669,0,0,1,.667.671v8.711l2.674-2.893h0a.663.663,0,0,1,.49-.216.668.668,0,0,1,.667.67.67.67,0,0,1-.18.459l-3.83,4.148a.666.666,0,0,1-.488.213A.663.663,0,0,1-176.489-167.45Z" transform="translate(184 179)" fill="#469595" />
                        </svg>
                    </a>
                    <button class="btn-delete" (click)="deleteFile(i, file.attachmentId)">
                        <svg width="8" height="8" viewBox="0 0 8 8">
                            <path id="remove-btn"
                              d="M4.217-7.853l-.805-.805L.217-5.464-2.978-8.658l-.805.805L-.589-4.658-3.783-1.464l.805.805L.217-3.853,3.411-.658l.805-.805L1.022-4.658Z"
                              transform="translate(3.783 8.658)" fill="#bbb" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>

        <div [hidden]='!docsEditable' class="dnd-container" appDnd
            (fileDropped)="onFileDropped($event)">
            <!-- *ngIf="files.length <5" -->
            <input type="file" #fileDropRef [attr.id]="'fileDropRef' + managerIndex" multiple
                (change)="fileBrowseHandler($event)"
                [accept]="inputAcceptString" />

            <div class="labels">
              <svg width="25" height="21" viewBox="0 0 25 21">
                <g id="cloud-upload-icon" opacity="0.6">
                  <path id="Path_1108" data-name="Path 1108"
                      d="M263.418,252.834A7.161,7.161,0,0,0,256.324,246a7.048,7.048,0,0,0-4.687,1.786,7.234,7.234,0,0,0-2.214,3.714,6.109,6.109,0,0,0,.131,12.214h2.076a.772.772,0,0,0,0-1.543h-2.076a4.565,4.565,0,0,1,0-9.129,4.166,4.166,0,0,1,.429.023.773.773,0,0,0,.833-.665,5.639,5.639,0,0,1,1.839-3.458,5.517,5.517,0,0,1,3.669-1.4,5.6,5.6,0,0,1,5.566,5.622c0,.11-.008.224-.021.4a.776.776,0,0,0,.23.606.752.752,0,0,0,.612.215,3.9,3.9,0,1,1,.393,7.783h-2.286a.772.772,0,0,0,0,1.543H263.1a5.446,5.446,0,0,0,.314-10.88Z"
                      transform="translate(-243.5 -246)" fill="#637d8f" />
                  <path id="Path_1109" data-name="Path 1109"
                      d="M257.245,250.61a.772.772,0,0,0,0-1.543,4.669,4.669,0,0,0-4.6,4.047.772.772,0,0,0,.656.868.75.75,0,0,0,.1.007.771.771,0,0,0,.76-.667A3.125,3.125,0,0,1,257.245,250.61Z"
                      transform="translate(-243.5 -246)" fill="#637d8f" />
                  <path id="Path_1110" data-name="Path 1110"
                      d="M258.927,260.014a.779.779,0,0,0-.061-1.088l-1.9-1.714a1.1,1.1,0,0,0-1.48,0l-1.9,1.714a.778.778,0,0,0-.06,1.088.764.764,0,0,0,1.086.062l.848-.765v6.918a.768.768,0,1,0,1.535,0v-6.918l.848.765A.789.789,0,0,0,258.927,260.014Z"
                      transform="translate(-243.5 -246)" fill="#637d8f" />
                </g>
              </svg>
              <h4>{{ 'group.DropFiles' | translate }}</h4>
              <span>{{ 'group.or' | translate }}</span>
              <label [attr.for]="'fileDropRef' + managerIndex">{{ 'group.BrowseFiles' | translate }}</label>
            </div>

            <ng-container *ngIf="showFilesInfo">
              <div class="my-2">{{ 'messages.Supported files' | translate }} ({{inputAcceptString}})</div>
              <div>
                <span>{{ 'messages.Max-file-size' | translate:{no: maxFileSize} }}</span>
              </div>
            </ng-container>
        </div>
        <div *ngIf="selectedfilesCount > maxFiles" class="has-error">{{ 'messages.Max-files' | translate }} {{maxFiles}}</div>
        <div *ngIf="!validFile" class="has-error">{{ 'messages.InvalidFile' | translate }}</div>
        <div *ngIf="fileMaxSiZeErorr" class="has-error">{{ 'messages.Max-file-size' | translate:{no: maxFileSize} }}</div>
        <div *ngIf="!files.length && isRequired && isSubmited" class="has-error">{{ 'messages.required' | translate }}</div>
    </div>
</div>
